<template>
  <div class="home-main">
    <div class="h_banner">
      <home-banner></home-banner>
    </div>
    <div class="h_summary">
      <home-summary></home-summary>
    </div>
    <div class="h_expert">
      <home-expert></home-expert>
    </div>
    <div class="h_product">
      <home-product></home-product>
    </div>
    <div class="h_news">
      <home-news></home-news>
    </div>
    <div class="h_link">
      <home-link></home-link>
    </div>
  </div>
</template>
<script>
import homeBanner from './banner';
import homeNews from './homeNews';
import homeMaster from './homeMaster';
import homeProduct from './homeProduct';
import homeLink from './homeLink';
import homeExpert from './homeExpert';
import homeSummary from './homeSummary';
export default {
  data() {
    return {};
  },
  components: {
    // globalHeader,
    // globalFooter,
    homeBanner,
    homeSummary,
    homeMaster,
    homeNews,
    homeProduct,
    homeLink,
    homeExpert
  },
  methods: {}
};
</script>
<style scoped>
.home-main {
  position: relative;
  z-index: 50;
}
.h_banner {
  width: 100%;
  height: 500px;
}
.h_summary {
  width: 100%;
  min-height: 690px;
  background-color: #fff;
}
.h_link {
  width: 100%;
  min-height: 240px;
}
.h_news {
  width: 100%;
  height: 635px;
  background-color: #fff;
}
.h_product {
  width: 100%;
  height: 545px;
  text-align: center;
  background-color: #fff;
}
.h_expert {
  width: 100%;
  height: 430px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/views/home/home.vue